import { render, staticRenderFns } from "./AdminList.vue?vue&type=template&id=bd109e42&scoped=true"
import script from "./AdminList.vue?vue&type=script&lang=js"
export * from "./AdminList.vue?vue&type=script&lang=js"
import style0 from "./AdminList.vue?vue&type=style&index=0&id=bd109e42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd109e42",
  null
  
)

export default component.exports